export default __webpack_public_path__ + "static/media/jobs-value-back-ourselves.12a8f094.svg";